import React from 'react';
import classNames from 'classnames';

import css from './ListingFormCard.module.css';

/**
 * Card wrapper for Edit Listing form sections.
 *
 * @component
 */
const ListingFormCard = props => {
  const { className, rootClassName, index, title, subtitle, children } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <section className={classes}>
      {title ? (
        <header className={css.header}>
          {index != null ? (
            <span className={css.index} aria-hidden="true">
              {index}
            </span>
          ) : null}
          <div className={css.titleBlock}>
            <div className={css.titleStack}>
              <h3 className={css.title}>{title}</h3>
              {subtitle ? <p className={css.subtitle}>{subtitle}</p> : null}
            </div>
          </div>
        </header>
      ) : null}
      <div className={css.body}>{children}</div>
    </section>
  );
};

export default ListingFormCard;
